<div class="modal-header" *ngIf="okOnly">
  <i class="bi bi-exclamation-triangle warning-icon"></i>
  <h4 class="modal-title">Warning</h4>
</div>
<div class="modal-body" *ngIf="okOnly">
    <span class="warning-text">{{ message }}</span>
  </div>

<div class="modal-footer" >
  <button class="btn btn-primary" (click)="cancel()">OK</button>
</div>
